import React from 'react';

export interface TagDataType {
  color: string;
  label: string;
  value?: string;
}

export interface TagProps {
  children: React.ReactNode;
  className?: string;
  color?: string;
}

export const Tag = ({ children, className, color }: TagProps) => (
  <span
    className={`font-semibold mr-2 px-6 truncate py-3 rounded text-white text-xs leading-12 pb-5 z-10 ${
      className || ''
    }`}
    style={{ backgroundColor: color }}
  >
    {children}
  </span>
);
